import { applyMiddleware, createStore } from "redux";
import rootReducer from "./root_reducer";
import logger from "redux-logger";

const middleWare=[logger];
//Console Logger
export const store = createStore(rootReducer, applyMiddleware(...middleWare));
// export const store = createStore(rootReducer);
export default store;
